import { createFileRoute } from '@tanstack/react-router'
import { FindGroupsDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import FindGroupsDialog from '@/routes/_app/-dialogs/find-groups'

export const Route = createFileRoute('/@modal/orgs/groups/find')({
  staticData: { slotScope: '/_app/orgs' },
  pendingComponent: FindGroupsDialogPending,
  component: FindGroupsSlot,
})

function FindGroupsSlot() {
  const slot = useModalSlot(Route)
  return <FindGroupsDialog {...slot} />
}
